<template>
  <div class="bill-filter-form custom-wrapper">
    <div class="filter-wrapper" >
      <el-form
        label-position="right"
        label-width="100px"
        ref="filterForm"
        :model="filterForm">

        <el-form-item label="订单号" prop="order_no">
          <el-input
            v-model="filterForm.order_no"
            placeholder="请输入订单号"
            @keyup.enter.native="onFilterSubmit" ></el-input>
        </el-form-item>

        <el-form-item label="设备号" prop="sn">
          <el-input
            v-model="filterForm.sn"
            placeholder="请输入设备号"
            @keyup.enter.native="onFilterSubmit" ></el-input>
        </el-form-item>

        <el-form-item label="交易方式" prop="client">
          <el-select
            v-model="filterForm.client"
            style="width: 100%;">
            <el-option label="全部" value=""></el-option>
            <el-option label="微信" value="wechat"></el-option>
            <el-option label="支付宝" value="alipay"></el-option>
            <el-option label="远程出货" value="remote"></el-option>
            <el-option label="硬币" value="coin"></el-option>
            <el-option label="纸币" value="bill"></el-option>
            <el-option label="礼品" value="gift"></el-option>
            <el-option label="悠游卡" value="ezcard"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="开始时间" prop="start_at">
          <el-date-picker
            v-model="filterForm.start_at"
            type="datetime"
            style="width: 100%;"
            placeholder="选择交易的起始时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="结束时间" prop="end_at">
          <el-date-picker
            v-model="filterForm.end_at"
            type="datetime"
            style="width: 100%;"
            placeholder="选择交易的截止时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="交易状态" prop="status">
          <el-select
            v-model="filterForm.status"
            style="width: 100%;">
            <el-option label="全部" value=""></el-option>
            <el-option label="未支付" value="0"></el-option>
            <el-option label="支付成功" value="1"></el-option>
            <el-option label="正在出货" value="2"></el-option>
            <el-option label="出货成功" value="3"></el-option>
            <el-option label="出货失败" value="4"></el-option>
            <el-option label="游戏成功" value="6"></el-option>
            <el-option label="游戏失败" value="7"></el-option>
            <el-option label="自动退款" value="8"></el-option>
            <el-option label="手动退款" value="9"></el-option>
            <el-option label="自动部分退款" value="10"></el-option>
            <el-option label="手动部分退款" value="11"></el-option>
            <el-option label="退款（不区分部分、手自动）" value="8,9,10,11"></el-option>
            <el-option label="异常" value="1,2,5"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          style="width: 100%;"
          label="代/商/区/门"
          v-if="hasRes('agent_index') || hasRes('user_index') || hasRes('user_area_index') || hasRes('user_store_index')" >
          <el-select
            filterable
            default-first-option
            v-model="filterForm.agentid"
            style="width: 24%;"
            v-if="hasRes('agent_index')"
            @change="onAgentSelected" >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="agent in agentList"
              :key="agent.agentid"
              :label="agent.agentname"
              :value="agent.agentid">
            </el-option>
          </el-select>
          <el-select
            filterable
            default-first-option
            v-model="filterForm.userid"
            @change="onUserSelected"
            style="width: 22%;"
            v-if="hasRes('user_index')" >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="user in userList"
              :key="user.userid"
              :label="user.username"
              :value="user.userid">
            </el-option>
          </el-select>
          <el-select
            filterable
            default-first-option
            v-model="filterForm.area"
            @change="onAreaSelected"
            style="width: 24%;"
            v-if="hasRes('user_area_index')">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="area in areaList"
              :key="area._id"
              :label="area.area_name"
              :value="area._id">
            </el-option>
          </el-select>
          <el-select
            filterable
            default-first-option
            v-model="filterForm.store"
            style="width: 24%;"
            v-if="hasRes('user_store_index')" >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="store in storeList"
              :key="store._id"
              :label="store.store_name"
              :value="store._id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="支付渠道" prop="status">
          <el-select
            v-model="filterForm.pay_channel"
            style="width: 100%;">
            <el-option label="全部" value="" />
            <el-option label="京东" value="jd" />
            <el-option label="扫呗" value="sb" />
            <el-option label="钱喵" value="qm" />
          </el-select>
        </el-form-item>

        <el-form-item label="收款账户" prop="status">
          <el-select
            v-model="filterForm.has_bank_no"
            style="width: 100%;">
            <el-option label="全部" value=""></el-option>
            <el-option label="未设置" :value="0"></el-option>
            <el-option label="已设置" :value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="设备类型" prop="dev_type">
          <el-select v-model="filterForm.dev_type" placeholder="请选择设备类型" style="width: 100%;">
            <el-option label="全部" value=""></el-option>
            <el-option label="线上商城" value="osm"></el-option>
            <el-option label="扭蛋机" value="gpm"></el-option>
            <el-option label="自动贩卖机" value="vm"></el-option>
            <el-option label="口红机" value="lpk"></el-option>
            <el-option label="脉冲" value="mc"></el-option>
            <el-option label="福袋机" value="fdj"></el-option>
            <el-option label="格子机" value="gzj"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="收款商户"
          prop="merchant_id"
          v-if="hasRes('merchant_info_index') ">
          <el-select
            filterable
            default-first-option
            v-model="filterForm.merchant_id"
            placeholder="请选择收款商户">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="merchant in merchantList"
              :key="merchant.merchant_id"
              :label="`${merchant.merchant_id} - ${merchant.users.length > 0 ?
                merchant.users[0].username : '未知'} - ${merchant.acct_name}`"
              :value="merchant.merchant_id"></el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <div class="submit">
        <el-button
          type="danger"
          size="medium"
          @click="onFilterSubmit">查询</el-button>
        <el-button
          size="medium"
          @click="resetFilters">重置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_PAGE, SET_FILTERS } from '@/store/modules/table'
import moment from 'moment'

export default {
  name: 'BillFilterForm',
  data () {
    return {
      filterForm: {
        start_at: '',
        end_at: '',
        sn: '',
        order_no: '',
        status: '',
        client: '',
        agentid: '',
        userid: '',
        store: '',
        area: '',
        pay_channel: '',
        has_bank_no: '',
        dev_type: '',
        merchant_id: ''
      }
    }
  },
  computed: {
    ...mapState('agent', [
      'agentList'
    ]),
    ...mapState('user', [
      'userList',
      'areaList',
      'storeList'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ]),
    ...mapState('bank', [
      'merchantList'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_PAGE,
      SET_FILTERS
    ]),
    ...mapActions('agent', [
      'getAgents'
    ]),
    ...mapActions('user', [
      'getUsers',
      'getAreas',
      'getStores'
    ]),
    ...mapActions('bank', [
      'getMerchants'
    ]),

    // 过滤相关
    onAgentSelected () {
      this.filterForm.user = ''
      this.filterForm.area = ''
      this.filterForm.store = ''
      if (this.hasRes('user_index')) {
        this.getUsers({
          page: 1,
          pageSize: 9999,
          filters: {
            agentid: this.filterForm.agentid
          }
        })
      }
      if (this.hasRes('user_area_index')) {
        this.getAreas({
          page: 1,
          pageSize: 9999,
          filters: {
            agentid: this.filterForm.agentid,
            userid: this.filterForm.userid
          }
        }).catch(err => {
          console.log(err)
        })
      }
      if (this.hasRes('user_store_index')) {
        this.getStores({
          page: 1,
          pageSize: 9999,
          filters: {
            agentid: this.filterForm.agentid,
            userid: this.filterForm.userid
          }
        })
      }
    },
    onUserSelected () {
      this.filterForm.area = ''
      this.filterForm.store = ''
      if (this.hasRes('user_area_index')) {
        this.getAreas({
          page: 1,
          pageSize: 9999,
          filters: {
            agentid: this.filterForm.agentid,
            userid: this.filterForm.userid
          }
        }).catch(err => {
          console.log(err)
        })
      }
      if (this.hasRes('user_store_index')) {
        this.getStores({
          page: 1,
          pageSize: 9999,
          filters: {
            agentid: this.filterForm.agentid,
            userid: this.filterForm.userid
          }
        })
      }
    },
    onAreaSelected () {
      this.filterForm.store = ''
      if (this.hasRes('user_store_index')) {
        this.getStores({
          page: 1,
          pageSize: 9999,
          filters: {
            agentid: this.filterForm.agentid,
            userid: this.filterForm.userid
          }
        })
      }
    },
    async getSelectDatas () {
      if (this.hasRes('agent_index')) {
        try {
          await this.getAgents({
            page: 1,
            pageSize: 9999
          })
        } catch (err) {
          console.log(err)
        }
      }

      // Get all users, areas, stores for select options
      if (this.hasRes('user_index')) {
        await this.getUsers({
          page: 1,
          pageSize: 9999
        }).catch(err => {
          console.log(err)
        })
      }
      if (this.hasRes('user_area_index')) {
        await this.getAreas({
          page: 1,
          pageSize: 9999
        }).catch(err => {
          console.log(err)
        })
      }
      if (this.hasRes('user_store_index')) {
        await this.getStores({
          page: 1,
          pageSize: 9999
        }).catch(err => {
          console.log(err)
        })
      }

      if (this.hasRes('merchant_info_index')) {
        try {
          await this.getMerchants({
            page: 1,
            pageSize: 9999
          })
        } catch (err) {
          console.log(err)
        }
      }
    },
    initTimeRange () {
      // Initialize the time filter
      const todayBegin = moment().startOf('day')
      const todayEnd = moment().endOf('day')

      this.filterForm.start_at = new Date(todayBegin)
      this.filterForm.end_at = new Date(todayEnd)

      this.setFilters(this.filterForm)
      // this.$emit('filter')
    },

    onFilterSubmit () {
      this.setPage(1)
      this.setFilters(this.filterForm)

      this.$emit('filter')
    },
    resetFilters () {
      this.$refs['filterForm'].resetFields()

      this.filterForm.agentid = ''
      this.filterForm.userid = ''
      this.filterForm.area = ''
      this.filterForm.store = ''
      this.filterForm.pay_channel = ''
      this.filterForm.dev_type = ''
      this.filterForm.has_bank_no = ''
      this.filterForm.merchant_id = ''
      this.getSelectDatas()
    }
  },
  mounted () {
    this.getSelectDatas()

    // Initialize the time range and fetch order list
    this.initTimeRange()
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";

.bill-filter-form {
}
</style>



// WEBPACK FOOTER //
// src/components/bill/BillFilterForm.vue